import { Dispatch, Action } from 'redux'
// import { SUBMIT_DELETE_TASK_TAG } from 'actions'
import { ToDoLinkMapDispatchReturnType } from './types/ToDoLinkMapDispatchReturnType'
import { createSetScrollPositionAction } from 'actionCreators/set/SetScrollPosition/createSetScrollPositionAction'

export const ToDoLinkMapDispatch = (
  dispatch: Dispatch<Action>
): ToDoLinkMapDispatchReturnType => {
  return {
    clearTodoScrollPosition: () => {
      dispatch(
        createSetScrollPositionAction({
          description: 'ToDoLinkMapDispatch',
          scrollPosition: {
            taskList: undefined,
            toDoPosition: 0,
          },
        })
      )
    },
  }
}
